import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle, ChalkActionButton } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";

export default function AdminPermissionTests() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [running, setRunning] = useState(false);

  async function run() {
    setRunning(true);
    try { setData(await api.adminPermissionTests()); }
    finally { setRunning(false); }
  }
  useEffect(() => { run(); }, []);

  const passed = data?.passed ?? 0;
  const total = data?.total ?? 0;
  const allPass = total > 0 && passed === total;

  return (
    <>
      <DarkHeader
        eyebrow="Admin"
        title="Permission tests"
        subtitle={data ? `${passed}/${total} passing` : "Loading"}
        right={<BackButton onClick={() => navigate(-1)} />}
      />
      <div style={{ padding: "0 18px 24px" }}>
        <ChalkActionButton testId="run-perm-tests" variant="ghost" label={running ? "Running…" : "Run again"} onClick={run} loading={running} />
        {data && (
          <ChalkCard style={{ marginTop: 12, background: allPass ? "#E1F5EE" : "#FAEEDA", borderColor: allPass ? "rgba(15,110,86,0.20)" : "rgba(180,83,9,0.20)" }}>
            <div style={{ fontSize: 15, fontWeight: 500, color: allPass ? "var(--sport-baseball-fg)" : "var(--chalk-amber)" }} data-testid="perm-tests-summary">
              {allPass ? "All checks passing." : `${total - passed} check${total - passed === 1 ? "" : "s"} failing.`}
            </div>
          </ChalkCard>
        )}

        <SectionTitle label="Results" />
        {data?.results.map((r, i) => (
          <ChalkCard key={i} style={{ marginTop: 6 }} data-testid={`perm-test-${i}`}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
              <div style={{ fontSize: 13, color: "var(--chalk-board)" }}>{r.name}</div>
              <span style={{
                fontSize: 11, fontWeight: 500, padding: "2px 8px", borderRadius: 999,
                background: r.pass ? "#E1F5EE" : "#FCEBEB",
                color: r.pass ? "var(--sport-baseball-fg)" : "var(--chalk-red)",
              }}>{r.pass ? "PASS" : "FAIL"}</span>
            </div>
          </ChalkCard>
        ))}
      </div>
    </>
  );
}
